import type { ILangData } from "@/queries/useTranslations";
import { type ILanguage, LANGUAGES } from "@/types";

const COPY_ROW_SEPARATOR = "\n\n\n";

export function buildCopyRowText(id: string, context: string, texts: ILangData, langs: ILanguage[]): string {
    const selectedLanguages = LANGUAGES.filter((lang) => langs.includes(lang));
    return [id, context, ...selectedLanguages.map((lang) => texts[lang])].join(COPY_ROW_SEPARATOR);
}
